import script from "./DomainModel.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainModel.vue?vue&type=script&setup=true&lang=js"

import "./DomainModel.vue?vue&type=style&index=0&id=e59aba46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e59aba46"]])

export default __exports__